module.exports = __webpack_public_path__ + "img/glassquality_7.ca7f661f.png";